export {LoginForm} from './LoginForm.connect';
